export default {
    computed:{
        nodes() {
            const nodes = [];
            const level1 = this.menus.filter(m => m.menuId.length === 2);
            const level2 = this.menus.filter(m => m.menuId.length === 4);
            const level3 = this.menus.filter(m => m.menuId.length === 6);

            for (const lv1 of level1) {
                const gNode = {
                    label: lv1.title,
                    children: [],
                    key: lv1.menuId,
                    raw: {...lv1},
                    isAuth: lv1.isAuth,
                    level: 1,
                    id: lv1.id
                };
                for (const lv2 of level2.filter(l2 => l2.menuId.substring(0, 2) === lv1.menuId)) {
                    const pNode = {
                        key: lv2.menuId,
                        label: lv2.title,
                        children: [],
                        raw: {...lv2},
                        parent: lv1.menuId,
                        isAuth: lv2.isAuth,
                        level: 2,
                        id: lv2.id
                    };

                    for (const lv3 of level3.filter(l3 => l3.menuId.substring(0, 4) === lv2.menuId)) {
                        const lNode = {
                            key: lv3.menuId,
                            label: lv3.title,
                            children: [],
                            raw: {...lv3},
                            parent: lv2.menuId,
                            isAuth: lv3.isAuth,
                            level: 3,
                            id: lv3.id
                        };
                        pNode.children.push(lNode);
                    }
                    gNode.children.push(pNode);
                }
                nodes.push(gNode);
            }
            const root = {
                isRoot: true,
                label: '根節點',
                children: nodes,
                key: 'root',
                level: 0
            };

            return [root];
        },

        leave(){
            const level1 = this.menus.filter(m => m.menuId.length === 2);
            const level2 = this.menus.filter(m => m.menuId.length === 4);
            const level3 = this.menus.filter(m => m.menuId.length === 6);
            const leave = [];
            for (const lv1 of level1) {
                const gNode = {
                    menuId: lv1.menuId,
                    id: lv1.id
                };

                //todo 可以優化
                if(level2.some(l2 => l2.menuId.substring(0, 2) === lv1.menuId)){
                    for (const lv2 of level2.filter(l2 => l2.menuId.substring(0, 2) === lv1.menuId)) {
                        const pNode = {
                            menuId: lv2.menuId,
                            id: lv2.id
                        };
                        if(level3.some(l3 => l3.menuId.substring(0, 4) === lv2.menuId)){
                            for (const lv3 of level3.filter(l3 => l3.menuId.substring(0, 4) === lv2.menuId)) {
                                const lNode = {
                                    menuId: lv3.menuId,
                                    id: lv3.id,
                                };
                                leave.push(lNode);
                            }
                        } else{
                            leave.push(pNode);
                        }
                    }
                } else{
                    leave.push(gNode);
                }
            }
            return leave;
        }
    }
}